import _import from '../_import'

export default [{
  path: 'staffs',
  name: 'staff-list',
  component: _import('staff/StaffList'),
  meta: {
    module: 'auth',
    tab: 'staff',
  },
}, {
  path: 'generate-qrcode',
  name: 'generate-qrcode-view',
  component: _import('staff/GenerateQrcodeView'),
  meta: {
    module: 'auth',
    tab: 'staff',
  },
}]
